module.exports = {
          srcSet: __webpack_public_path__ + "public/53951616a132b1826340870813b829ae-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/53951616a132b1826340870813b829ae-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/53951616a132b1826340870813b829ae-80.png",
          toString:function(){return __webpack_public_path__ + "public/53951616a132b1826340870813b829ae-80.png"},
          
          width: 80,
          height: 80
        }